import {Outlet, RouteObject, useRoutes} from 'react-router-dom';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {ActiveWorkspaceProvider} from '@common/workspace/active-workspace-id-context';
// import { LoanProductPage, NewLoanProductPage, UpdateLoanProductPage, ViewLoanProductPage } from './loan-products-page';
import { AuthRoute } from '@common/auth/guards/auth-route';
import { PricingEngineSetupLayout } from '@common/pricing-engine-setup/pricing-engine-setup-layout';
import { LoanProductPage, ViewLoanProductPage } from './loan-products-page';
import { UwConditionViewPage } from '@app_modules/loan-applications/loan-application-detail';
import { LoanProgramViewPage } from './loan-product-detail';

export default function LoanProductRoutes() {
  const DashboardRouteConfig: RouteObject[] = [
    {
      path: '',
      // element: (
      //   <ActiveWorkspaceProvider>
      //     <Outlet />
      //   </ActiveWorkspaceProvider>
      // ),
      element: <PricingEngineSetupLayout />,
      children: [
        {
          path: '/',
          element: (
            <AuthRoute permission="loan_products.view">
              <LoanProductPage />
            </AuthRoute>
          ),
        },
        {
          path: ':loanProductId/view',
          element: (
            <AuthRoute permission="loan_products.view">
              <ViewLoanProductPage />
            </AuthRoute>
          ),
        },
        {
          path: ':id/loan-program-view',
          element: (
            <AuthRoute permission="loan_products.view">
              <LoanProgramViewPage />
            </AuthRoute>
          ),
        },

        {path: '*', element: <NotFoundPage />},
      ],
    },
  ];

  return useRoutes(DashboardRouteConfig);
}
